{
  "version": 1,
  "asset_id": "1f5c8891-0cf5-4b09-8396-26012891cc37",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/1f5c8891-0cf5-4b09-8396-26012891cc37/bypass-weight-loss-graph-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/1f5c8891-0cf5-4b09-8396-26012891cc37/bypass-weight-loss-graph-1200.webp",
  "original_filename": "bypass-weight-loss-graph-1200.webp",
  "size": 31858,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:12:38Z"
}
